import { IFilters, IPaginateResponse } from "@/interfaces/Fetch";
import CallLog, {
  CallLogDirection,
  CallStats,
  CallMeetingResult,
} from "@/interfaces/CallLog";
import User from "@/interfaces/IUser";
import api from "./api";

export const callLogsApi = api.injectEndpoints({
  endpoints: (builds) => ({
    getCallLogs: builds.query<
      IPaginateResponse<CallLog> & { actorFilterAvailable?: boolean },
      IFilters & {
        userId?: string;
        actorUserId?: string;
        softphoneLineId?: string;
        companyId?: string;
        personId?: string;
        instructorId?: string;
        direction?: CallLogDirection;
        missed?: boolean;
        days?: number;
        meetingResult?: CallMeetingResult;
      }
    >({
      query: (params) => ({
        url: "/call-logs",
        params,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.data.map(({ id }) => ({
                type: "CallLogs" as const,
                id,
              })),
              { type: "CallLogs", id: "LIST" },
              { type: "CompanyMeetings", id: "LIST" },
              { type: "Meetings", id: "LIST" },
              { type: "MontageMeetings", id: "LIST" },
            ]
          : [
              { type: "CallLogs", id: "LIST" },
              { type: "CompanyMeetings", id: "LIST" },
              { type: "Meetings", id: "LIST" },
              { type: "MontageMeetings", id: "LIST" },
            ],
    }),
    getCallStats: builds.query<
      CallStats,
      {
        userId?: string;
        actorUserId?: string;
        days?: number;
        query?: string;
        meetingResult?: CallMeetingResult;
      }
    >({
      query: (params) => ({
        url: "/call-logs/stats",
        params,
      }),
      providesTags: [
        { type: "CallLogs", id: "LIST" },
        { type: "CompanyMeetings", id: "LIST" },
        { type: "Meetings", id: "LIST" },
        { type: "MontageMeetings", id: "LIST" },
      ],
    }),
    // Members whose calls a team lead can see; empty for anyone leading no team.
    getCallLogUsers: builds.query<User[], void>({
      query: () => "/call-logs/users",
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetCallLogsQuery,
  useGetCallStatsQuery,
  useGetCallLogUsersQuery,
} = callLogsApi;
